module.exports = __webpack_public_path__ + "img/management-share-1.251bc27d.png";